"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_TYPE_NAMES = exports.AgeGroupsSeen = exports.AddressInputRow = exports.TimeInput = exports.TextareaInput = exports.TextInput = exports.SimpleSelectInput = exports.SelectInput = exports.SSNInput = exports.RadioInput = exports.PhoneInput = exports.NPIInput = exports.MultiSelectInput = exports.EmailInput = exports.DateInput = exports.DOBInput = exports.CheckboxInput = exports.AddOn = exports.getAddOns = exports.Footer = exports.Header = exports.FormContext = exports.validators = exports.useValidation = exports.types = void 0;
const react_1 = __importDefault(require("react"));
const types = __importStar(require("./types"));
exports.types = types;
const container_1 = __importDefault(require("./form/container"));
const use_form_1 = require("./form/use-form");
Object.defineProperty(exports, "FormContext", { enumerable: true, get: function () { return use_form_1.FormContext; } });
const validators_1 = __importDefault(require("./validation/validators"));
exports.validators = validators_1.default;
const get_field_configs_1 = __importDefault(require("./form/get-field-configs"));
const use_validation_1 = __importDefault(require("./validation/use-validation"));
exports.useValidation = use_validation_1.default;
const AddOn_1 = __importDefault(require("./getAddOns/AddOn"));
exports.AddOn = AddOn_1.default;
const FormComponent = (props) => {
    const fieldAddOns = {};
    const formAddOns = {
        Footer: null,
        Header: null
    };
    /**
     * Separate children into fieldAddOns and header/footer add-ons
     */
    react_1.default.Children.forEach(props.children, (Child) => {
        if (!Child)
            return;
        if (typeof Child === 'object' && 'props' in Child) {
            if (Child.props.addOnType) {
                const Component = (props) => react_1.default.cloneElement(Child, props);
                fieldAddOns[Child.props.addOnType] = Component;
            }
            if (Child.props._componentName === 'Footer') {
                formAddOns.Footer = (props) => react_1.default.cloneElement(Child, props);
            }
            if (Child.props._componentName === 'Header') {
                formAddOns.Header = (props) => react_1.default.cloneElement(Child, props);
            }
        }
    });
    const fields = (0, get_field_configs_1.default)(props);
    const hasConditionals = fields.some((field) => field.isConditional());
    return (react_1.default.createElement(container_1.default, Object.assign({}, props, { fieldAddOns: fieldAddOns, formAddOns: formAddOns, fields: fields, hasConditionals: hasConditionals })));
};
/**
 * Here we create shell components for the Header and Footer.
 * This allows us to give them a _componentName prop so they
 * can be extracted above via extractComponents().
 *
 * Both are meant to be used by a consumer as children.
 * Example:

   import Form, {Header} from '@kyruus/forms-v2'

   <Form {...props}>
    <Header>
      {({handleSubmit}) => <MyCustomHeader submit={handleSubmit} />}
    </Header>
   </Form>
 */
const Footer = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return children(props);
};
exports.Footer = Footer;
Footer.defaultProps = { _componentName: 'Footer' };
const Header = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return children(props);
};
exports.Header = Header;
Header.defaultProps = { _componentName: 'Header' };
// () => true prevents consumer from rerendering form via prop changes
const Form = react_1.default.memo(FormComponent, () => true);
exports.default = Form;
var getAddOns_1 = require("./getAddOns");
Object.defineProperty(exports, "getAddOns", { enumerable: true, get: function () { return __importDefault(getAddOns_1).default; } });
var inputs_1 = require("./fields/inputs");
Object.defineProperty(exports, "CheckboxInput", { enumerable: true, get: function () { return inputs_1.CheckboxInput; } });
Object.defineProperty(exports, "DOBInput", { enumerable: true, get: function () { return inputs_1.DOBInput; } });
Object.defineProperty(exports, "DateInput", { enumerable: true, get: function () { return inputs_1.DateInput; } });
Object.defineProperty(exports, "EmailInput", { enumerable: true, get: function () { return inputs_1.EmailInput; } });
Object.defineProperty(exports, "MultiSelectInput", { enumerable: true, get: function () { return inputs_1.MultiSelectInput; } });
Object.defineProperty(exports, "NPIInput", { enumerable: true, get: function () { return inputs_1.NPIInput; } });
Object.defineProperty(exports, "PhoneInput", { enumerable: true, get: function () { return inputs_1.PhoneInput; } });
Object.defineProperty(exports, "RadioInput", { enumerable: true, get: function () { return inputs_1.RadioInput; } });
Object.defineProperty(exports, "SSNInput", { enumerable: true, get: function () { return inputs_1.SSNInput; } });
Object.defineProperty(exports, "SelectInput", { enumerable: true, get: function () { return inputs_1.SelectInput; } });
Object.defineProperty(exports, "SimpleSelectInput", { enumerable: true, get: function () { return inputs_1.SimpleSelectInput; } });
Object.defineProperty(exports, "TextInput", { enumerable: true, get: function () { return inputs_1.TextInput; } });
Object.defineProperty(exports, "TextareaInput", { enumerable: true, get: function () { return inputs_1.TextareaInput; } });
Object.defineProperty(exports, "TimeInput", { enumerable: true, get: function () { return inputs_1.TimeInput; } });
var rows_1 = require("./fields/rows");
Object.defineProperty(exports, "AddressInputRow", { enumerable: true, get: function () { return rows_1.AddressInputRow; } });
Object.defineProperty(exports, "AgeGroupsSeen", { enumerable: true, get: function () { return rows_1.AgeGroupsSeen; } });
var constants_1 = require("./constants");
Object.defineProperty(exports, "FIELD_TYPE_NAMES", { enumerable: true, get: function () { return constants_1.FIELD_TYPE_NAMES; } });
//# sourceMappingURL=index.js.map